// @ts-check
import clsx from 'clsx'
import { useLocation } from 'react-router-dom'

/** @typedef {{ className?: string }} Props */
/** @param {Props} props */
export default function CategoryNav({ className }) {
  const { pathname } = useLocation()

  const checkPath = new RegExp('^/$|^/(models|creatives|fashion|beauty|activism)/?([0-9]+)?$')
  const shouldRender = checkPath.test(pathname)

  // If the path doesn't match, render nothing.
  if (!shouldRender) {
    return null
  }

  // If it should render, calculate the active category directly from the path.
  const pathSegments = pathname.split('/')
  const activeCategory = pathSegments.length > 1 ? pathSegments[1] : null

  return (
    <ul className={clsx('sb-menu sb-menu--small', className)}>
      <li
        className={`sb-menu__item ${activeCategory === 'models' ? 'sb-menu__item--selected' : ''}`}
      >
        <a className="sb-link" href="/models">
          Models.
        </a>
      </li>
      <li
        className={`sb-menu__item ${
          activeCategory === 'creatives' ? 'sb-menu__item--selected' : ''
        }`}
      >
        <a className="sb-link" href="/creatives">
          Creatives.
        </a>
      </li>
      <li
        className={`sb-menu__item ${activeCategory === 'fashion' ? 'sb-menu__item--selected' : ''}`}
      >
        <a className="sb-link" href="/fashion">
          Fashion.
        </a>
      </li>
      <li
        className={`sb-menu__item ${activeCategory === 'beauty' ? 'sb-menu__item--selected' : ''}`}
      >
        <a className="sb-link" href="/beauty">
          Beauty.
        </a>
      </li>
    </ul>
  )
}
